import { useGetControlPrograms } from "api/generated/control-program/control-program";

export const useSearchControlProgramQuery = (search: string) =>
    useGetControlPrograms(
        { name: search },
        {
            query: {
                select: (response) => {
                    const data = response.data;
                    return data.content.map((dto) => dto.resource);
                },
                staleTime: 30 * 1000,
            },
        }
    );
